import { Component, OnInit } from '@angular/core';
import { ResponsiveService } from 'src/app/tools/services/responsive.service';


@Component({
  selector: 'app-welcome',
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit {

  isMobile      : boolean = false;

  constructor(
    protected responsiveService   : ResponsiveService,
  ) { }

  ngOnInit() {    
      this.responsiveService.getMobileStatus().subscribe( isMobile =>{
      this.isMobile = isMobile;
    });
    
    this.responsiveService.checkWidth();
  }

}
